import {useMutation} from "@tanstack/react-query";
import {updateFacility} from "../services/FacilityService";

export function useFacilityUpdate() {
    return useMutation({
        mutationFn: updateFacility,
    });
}
